import React, { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const formats = ["header", "bold", "italic", "underline", "blockquote", "list", "bullet", "link"];

export default function RichTextEditor({ value = "", onChange, className = "", placeholder = "" }) {
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    const quill = new Quill(editorRef.current, { theme: "snow", modules, formats, placeholder });
    quillRef.current = quill;
    const handleTextChange = () => onChangeRef.current?.(quill.root.innerHTML);
    quill.on("text-change", handleTextChange);

    return () => {
      quill.off("text-change", handleTextChange);
      quillRef.current = null;
      if (editorRef.current) editorRef.current.replaceChildren();
    };
  }, [placeholder]);

  useEffect(() => {
    const quill = quillRef.current;
    if (!quill || quill.root.innerHTML === value) return;
    quill.setContents(quill.clipboard.convert(value || ""));
  }, [value]);

  return <div className={`rich-text-editor ${className}`.trim()} ref={editorRef} />;
}